import type {
  MultipleProductCard,
  SingularProductCard
} from "@shared/graphql.types";
import { Typography } from "@shared/ui.primitives";

import {
  CtaButtonAction,
  HorizontalProductCardWrapper
} from "packages/acquisition/shared/components/ProductCardWrapper/HorizontalProductCardWrapper";

import * as styles from "./PairsWith.css";
import { isMultipleProductCard } from "packages/core-shopping/shared/isMultipleProductCard";

type Props = {
  productCards?: (SingularProductCard | MultipleProductCard)[];
  onAddToBag: (sku: string) => void;
};

export const PairsWith = ({ productCards = [], onAddToBag }: Props) => {
  return (
    <div className={styles.wrapper}>
      <Typography variant="subheader-3" colour="primary-dark">
        Pairs Well With
      </Typography>

      <ul className={styles.listContainer}>
        {productCards.map((card, index) => {
          const isMultiVariant = isMultipleProductCard(card);

          return (
            <li className={styles.listItem} key={`header-image-${index}`}>
              <HorizontalProductCardWrapper
                location="pairsWith"
                productCard={card}
                styles={{ variant: "carousel", buttonVariant: "secondary" }}
                addToBasketOptions={{
                  afterAdd: (variant) => {
                    const sku = variant.sku;
                    if (sku) {
                      onAddToBag?.(sku);
                    }
                  }
                }}
                ctaButtonAction={
                  isMultiVariant
                    ? CtaButtonAction.SELECT_SHADE
                    : CtaButtonAction.ADD_TO_BASKET
                }
              />
            </li>
          );
        })}
      </ul>
    </div>
  );
};
